<template>
    <div class="box-wrap">
        <div class="brian">
            <Brian/>
        </div>
        <div class="box">
            <template v-if="isWaitingForAuthResponse">
	            <Loader/>
            </template>
            <template v-else>
                <div v-if="errorMsg !== ''" class="error-message">{{errorMsg}}</div>
                <p>Du har allerede købt en billet. Indtast den fremsendte kode nedenfor:</p>
                <input v-model="token" @focus="clearInputs" placeholder="Skriv kode her..." />
                <button @click="attemptLogin" class="big">Kom indenfor!</button>
            </template>
        </div>
    </div>
</template>

<script>
	import Brian from "@/assets/login/brian.svg"
	import {setCookie} from "@/helperFunctions";
	import {mapState} from "vuex";
	import Loader from "@/components/Loader";
	export default {
		components: {
			Loader,
			Brian
        },
		data(){
			return {
				token: '',
                errorMsg: '',
				isWaitingForAuthResponse: false
			}
		},
		computed: {
			...mapState('vorbasse', {
				isAuthorized: 'isAuthorized',
				hasPerformedInitialLoad: 'hasPerformedInitialLoad'
			})
		},
		methods: {
			clearInputs(){
				this.token = ''
                this.errorMsg = ''
            },
			attemptLogin()
			{
				if(this.token !== '')
				{
					const that = this;
					this.performAuthorization(this.token)
					.then(response => {
						that.$store.commit('ux/setGuideState', '')
						that.$router.push({name:'univers'})
					})
					.catch(error => {
						that.errorMsg = 'Du kunne ikke logges ind, tjek dine indtastninger'
					})
				}
				else
				{
					this.errorMsg = 'Du skal indtaste noget i feltet'
				}
			},
			performAuthorization(token)
			{
				return new Promise((resolve, reject) =>
				{
					if(this.isAuthorized === true)
					{
						resolve(true);
					}
					else
					{
						const that = this;
						const key = this.$vorbasseSocket.onCommand('authorization-result',(result) => {
							this.$vorbasseSocket.dropCommandListener('authorization-result',key);
							that.isWaitingForAuthResponse = false;
							if(typeof result.result !== 'undefined' && result.result === 200 && typeof result.data !== 'undefined')
							{
								setCookie('auth-token',result.data,24*365);
								that.$store.commit('vorbasse/reset');
								resolve(true);
							}
							else
							{
								reject(false);
							}
						});

						this.isWaitingForAuthResponse = true;
						this.$vorbasseSocket.emit('attempt-authorize',token)
					}
				});
			}
		}
	};
</script>

<style scoped>

</style>
